import { Link } from "react-router-dom";

export function LoginHelp() {
  return (
    <div className="px-5 mx-auto min-h-screen max-w-5xl">
      <div className="my-10">
        <Link
          to={"/help"}
          className="text-sm text-blue-500 underline flex mb-4"
        >
          Back To Help
        </Link>
        <h2 className="text-3xl font-bold">Login</h2>
      </div>

      <div id="page-wrapper">
        <p>You must login with your email address and password.</p>

        <p className="my-10">
          <strong className="flex mb-3">Forgot password?</strong>
          <ul style={{ listStyle: "number" }}>
            <li>
              Go to{" "}
              <a
                href="https://hub.expensehut.com/forgot-password"
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 underline"
              >
                Hub
              </a>{" "}
              and enter your email address.
            </li>
            <li>A one time passcode will be sent to your email.</li>
            <li>
              Once you enter this code, you will be able to successfully reset
              your password.
            </li>
          </ul>
        </p>

        <br />
        <hr />
      </div>
    </div>
  );
}
